import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PersquisaService } from 'src/app/service/persquisa.service';

@Component({
  selector: 'app-dialog-escolher-grupo',
  templateUrl: './dialog-escolher-grupo.component.html',
  styleUrls: ['./dialog-escolher-grupo.component.css']
})
export class DialogEscolherGrupoComponent implements OnInit {

  constructor(
    private pesquisaService: PersquisaService,
    private domSanitizer: DomSanitizer
  ) { }

  grupos: any;
  fk_grupo: any;

  ngOnInit(): void {
    this.listarNotas();
  }

  listarNotas() {
    this.pesquisaService.listarNotas().subscribe(grupos => {
      grupos.forEach((element: any) => {
        element.notas.forEach((nota: any) => {
          nota.vc_icone = this.domSanitizer.bypassSecurityTrustUrl(nota.vc_icone);
        });
      });
      this.grupos = grupos
    })
  }

  salvarGrupo(fk_grupo: any) {
    this.fk_grupo = fk_grupo
  }
}

